import React from 'react';
import styled, { css } from 'styled-components/macro';
import { useNomenclator } from '../contexts/nomenclatorContext';
import { usePage } from '../contexts/pageContext';
import { useIsMobile } from '../hooks/useMediaQuery';
import { useEleccion, useSetEleccion } from '../contexts/eleccionContext';
import { responsive } from '../resources/constantes.json';
import DropdownSelectorCamara from '../containers/DropdownSelectorCamara';

const ContenedorSelectorCamaras = () => {
  const elecOptions = useEleccion();
  const setElecOptions = useSetEleccion();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const { urlInfo } = pageState;
  const { idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const isMobile = useIsMobile();
  const showCamaras = elecOptions.camaras.length > 0;
  const InfoEleccion = nomenclator.nomAmbitos[elecOptions.idEleccion];
  const colorCamara = InfoEleccion.cam[elecOptions.selectedCamara.cam].co;
  return (
    <>
      <ContainerCamaras primerColor={colorCamara}>
        {showCamaras &&
          (!isMobile ? (
            elecOptions.camaras.map((camara, i) => {
              return (
                <BotonCamara
                  selected={camara.cam === elecOptions.selectedCamara.cam}
                  key={i}
                  onClick={() => {
                    setElecOptions({ ...elecOptions, selectedCamara: camara });
                  }}
                >
                  {'Circunscripción ' +
                    nomenclator.nomAmbitos[elecOptions.idEleccion].cam[
                      camara.cam
                    ].ca.toLowerCase()}
                </BotonCamara>
              );
            })
          ) : (
            <DropdownSelectorCamara
              elecOptions={elecOptions}
              nomenclator={nomenclator}
              selectedCamara={elecOptions.selectedCamara}
            />
          ))}
      </ContainerCamaras>
    </>
  );
};

const ContainerCamaras = styled(({ primerColor, ...rest }) => (
  <div {...rest} />
))`
  display: none;
  width: 100%;
  justify-content: space-between;
  background: #fff;
  border-bottom: 10px solid ${({ primerColor }) => primerColor};
  @media (max-width: ${responsive.mobile}px) {
    background: white;
  }
`;

const BotonCamara = styled(({ selected, ...rest }) => <button {...rest} />)`
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  background: transparent;
  color: ${({ selected }) => (selected ? '#1C283D' : '#C4C4C4')};
  padding: 12px 5px 12px 5px;
  :first-letter,
  :first-line {
    text-transform: capitalize;
  }
`;

export default ContenedorSelectorCamaras;
